import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Home, FileText, CheckCircle, LifeBuoy, ShieldCheck } from "lucide-react";
import igbslogo from "../assets/igbslogo.png";
import cdfLogo  from "../assets/cdfLogo.png";

const Navbar = ({ isNavOpen, setIsNavOpen }) => {
  const { pathname } = useLocation();

  return (
    <header className="fixed top-0 w-full z-50">
      <nav className="bg-blue-700 text-white border-b border-blue-800 shadow-md">

        <div className="w-full px-4 sm:px-6 flex justify-between items-center h-16">

          <Link
            to="/"
            className="flex items-center gap-2 font-bold text-lg md:text-xl hover:opacity-90 transition-opacity duration-150"
            onClick={() => setIsNavOpen(false)}
          >
            <img src={cdfLogo}  alt="CDF Logo"  className="h-8 md:h-12 lg:h-14 w-auto object-contain" />
            <img src={igbslogo} alt="IGBS Logo" className="h-8 md:h-12 lg:h-14 w-auto object-contain" />
            <span className="hidden sm:inline">IGBS Portal</span>
          </Link>

          <div className="hidden md:flex items-center gap-6 text-sm font-medium">
            <NavLink to="/"            icon={<Home size={16} />}        label="Home"         active={pathname === "/"} />
            <NavLink to="/login"       icon={<FileText size={16} />}    label="Apply"        active={false} />
            <NavLink to="/login"       icon={<CheckCircle size={16} />} label="Check Status" active={false} />
            <NavLink to="/eligibility" icon={<ShieldCheck size={16} />} label="Eligibility"  active={pathname === "/eligibility"} />
            <NavLink to="/support"     icon={<LifeBuoy size={16} />}    label="Support"      active={pathname === "/support"} />
          </div>

          <button
            onClick={() => setIsNavOpen(!isNavOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-blue-800 transition-colors focus:outline-none focus:ring-2 focus:ring-white/50"
            aria-label="Toggle navigation menu"
          >
            {isNavOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {isNavOpen && (
          <div className="md:hidden absolute right-0 bg-blue-800 border-t border-blue-900 px-4 py-3 space-y-1 min-w-[200px] shadow-lg">
            <MobileNavLink to="/"            label="Home"         setIsNavOpen={setIsNavOpen} />
            <MobileNavLink to="/login"       label="Apply"        setIsNavOpen={setIsNavOpen} />
            <MobileNavLink to="/login"       label="Check Status" setIsNavOpen={setIsNavOpen} />
            <MobileNavLink to="/eligibility" label="Eligibility"  setIsNavOpen={setIsNavOpen} />
            <MobileNavLink to="/support"     label="Support"      setIsNavOpen={setIsNavOpen} />
          </div>
        )}
      </nav>
    </header>
  );
};

const NavLink = ({ to, icon, label, active }) => (
  <Link
    to={to}
    className={`flex items-center gap-1.5 transition-colors duration-150 py-1 border-b-2 ${
      active ? "border-yellow-300 text-yellow-300" : "border-transparent hover:text-yellow-300 hover:border-yellow-300/50"
    }`}
  >
    {icon}
    <span>{label}</span>
  </Link>
);

const MobileNavLink = ({ to, label, setIsNavOpen }) => (
  <Link
    to={to}
    onClick={() => setIsNavOpen(false)}
    className="flex items-center px-3 py-2.5 rounded-lg text-sm font-medium hover:bg-blue-700 hover:text-yellow-300 transition-colors duration-150"
  >
    {label}
  </Link>
);

export default Navbar;